import React, { useEffect, useRef, useState } from 'react'

export type AgTechFixedContainerProps = {
    children: React.ReactNode,
    classes?: string
}

const AgTechFixedContainer = (props: AgTechFixedContainerProps) => {
    const containerRef = useRef<HTMLDivElement>(null);

    const [containerSize, setContainerSize] = useState<{ height?: number, width?: number }>({
        height: undefined,
        width: undefined
    });

    useEffect(() => {
        if (containerRef.current) {
            setContainerSize({
                height: containerRef.current.clientHeight,
                width: containerRef.current.clientWidth
            });
        }
    }, []);

    return (
        <div
            ref={containerRef}
            className={`stretched ${props.classes ?? ''} flex`}
            style={{ 
                minHeight: containerSize.height,
                minWidth: containerSize.width
            }}
        >
            {props.children}
        </div>
    )
}

export default AgTechFixedContainer